import { ToastModule } from 'primeng/toast';
import { SwiperModule } from 'swiper/angular';
import localeEs from '@angular/common/locales/es';
import { LOCALE_ID, NgModule } from '@angular/core';
import { NgxPaginationModule } from 'ngx-pagination';
import { AppRoutingModule } from './app-routing.module';
import { environment } from '../environments/environment';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { PrimengModule } from './extra-module/primeng.module';
import { MaterialModule } from './extra-module/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { provideHttpClient, withFetch } from '@angular/common/http';
// import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from "ng-recaptcha";
// delete next line
// import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
// delete next line
// import { AngularFireAnalyticsModule } from '@angular/fire/compat/analytics';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { AppComponent } from './app.component';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { BlogPageComponent } from './pages/blog-page/blog-page.component';
import { FaqsPageComponent } from './pages/faqs-page/faqs-page.component';
import { LoaderComponent } from './components/shared/loader/loader.component';
import { FooterComponent } from './components/shared/footer/footer.component';
import { NavbarComponent } from './components/shared/navbar/navbar.component';
import { QuoterPageComponent } from './pages/quoter-page/quoter-page.component';
import { JobBoardPageComponent } from './pages/job-board-page/job-board-page.component';
import { BannerHomeComponent } from './components/home/banner-home/banner-home.component';
import { ContactHomeComponent } from './components/home/contact-home/contact-home.component';
import { SingleBlogPageComponent } from './pages/single-blog-page/single-blog-page.component';
// import { HowPossibleHomeComponent } from './components/home/how-possible-home/how-possible-home.component';
import { WhyChooseUsHomeComponent } from './components/home/why-choose-us-home/why-choose-us-home.component';
import { AdvisoryDirectoryPageComponent } from './pages/advisory-directory-page/advisory-directory-page.component';
import { WeAreUniversalHomeComponent } from './components/home/we-are-universal-home/we-are-universal-home.component';
import { ReviewsHomeComponent } from './components/home/reviews-home/reviews-home.component';
import { registerLocaleData } from '@angular/common';
import { ThanksQuotePageComponent } from './pages/thanks-quote-page/thanks-quote-page.component';
import { ThankYouPageComponent } from './pages/thank-you-page/thank-you-page.component';
import { ModalHomeComponent } from './components/home/modal-home/modal-home.component';
import { ModalQuoteComponent } from './components/quote/modal-quote/modal-quote.component';
import { TeamMembersHomeComponent } from './components/home/team-members-home/team-members-home.component';
import { ResponsibleCompanyComponent } from './components/home/responsible-company/responsible-company.component';
// import { GalleryComponent } from './components/home/gallery/gallery.component';
import { MisionComponent } from './components/home/mision/mision.component';
import { SingleProjectPageComponent } from './pages/single-project-page/single-project-page.component';
import { A11yModule } from "@angular/cdk/a11y";
import { NgOptimizedImage } from '@angular/common';
import { ServiceWorkerModule } from '@angular/service-worker';
import { CarouselComponent } from './components/shared/carousel/carousel.component';
import { CornerCardComponent } from './components/shared/corner-card/corner-card.component';
import { ButtonComponent } from './components/shared/button/button.component';
import {
  LucideAngularModule,
  ArrowUpRight,
  Target,
  Leaf,
  ShieldCheck,
  Handshake,
  Award,
  Building2,
  PiggyBank,
  FileText,
  Landmark,
  Zap,
  Wrench,
  Hammer,
  Home,
  Factory,
  Activity,
  Lightbulb,
  MapPin
} from 'lucide-angular';
import { StatsComponent } from './components/home/stats/stats.component';
import { AboutUsComponent } from './components/home/about-us/about-us.component';
import { BadgeComponent } from './components/shared/badge/badge.component';
import { HowDoWeBuildComponent } from './components/home/how-do-we-build/how-do-we-build.component';
import { OurValuesComponent } from './components/home/our-values/our-values.component';
import { CredibilityComponent } from './components/home/credibility/credibility.component';
import { ManifiestoComponent } from './components/home/manifiesto/manifiesto.component';
import { TrayectoriaComponent } from './components/home/trayectoria/trayectoria.component';
import { OurServicesComponent } from './components/home/our-services/our-services.component';
import { WeBuildTrustComponent } from './components/home/we-build-trust/we-build-trust.component';

// import { ProjectComponent } from './services/project/project/project.component';

registerLocaleData(localeEs);

@NgModule({
  declarations: [
    AppComponent,
    HomePageComponent,
    QuoterPageComponent,
    NavbarComponent,
    FooterComponent,
    BannerHomeComponent,
    WeAreUniversalHomeComponent,
    // HowPossibleHomeComponent,
    WhyChooseUsHomeComponent,
    ContactHomeComponent,
    BlogPageComponent,
    FaqsPageComponent,
    AdvisoryDirectoryPageComponent,
    JobBoardPageComponent,
    SingleBlogPageComponent,
    LoaderComponent,
    ReviewsHomeComponent,
    ThanksQuotePageComponent,
    ThankYouPageComponent,
    ModalHomeComponent,
    ModalQuoteComponent,
    TeamMembersHomeComponent,
    ResponsibleCompanyComponent,
    // GalleryComponent,
    MisionComponent,
    SingleProjectPageComponent,
    CornerCardComponent,
    ButtonComponent,
    StatsComponent,
    AboutUsComponent,
    BadgeComponent,
    HowDoWeBuildComponent,
    OurValuesComponent,
    CredibilityComponent,
    ManifiestoComponent,
    TrayectoriaComponent,
    OurServicesComponent,
    WeBuildTrustComponent,
    // ProjectComponent,
    // CarouselComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:30000'
    }),
    SwiperModule,
    PrimengModule,
    MaterialModule,
    ToastModule,
    ConfirmDialogModule,
    NgxPaginationModule,
    // RecaptchaV3Module,
    A11yModule,
    NgOptimizedImage,
    CarouselComponent,
    LucideAngularModule.pick({
      ArrowUpRight,
      Target,
      Leaf,
      ShieldCheck,
      Handshake,
      Award,
      Building2,
      PiggyBank,
      FileText,
      Landmark,
      Zap,
      Wrench,
      Hammer,
      Home,
      Factory,
      Activity,
      Lightbulb,
      MapPin
    })

  ],
  providers: [
    provideHttpClient(withFetch()),
    provideClientHydration(),
    provideAnimationsAsync(),
    { provide: LOCALE_ID, useValue: 'es' },
    MessageService,
    ConfirmationService,
    // { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.CAPTCHA_KEY }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
